/* eslint-disable no-console */
import { useRef, useEffect } from 'react';
import * as Sentry from '@sentry/react';

const logPropDifferences = (newProps, lastProps) => {
  const allKeys = new Set(Object.keys(newProps)).add(Object.keys(lastProps));
  allKeys.forEach((key) => {
    const newValue = newProps[key];
    const lastValue = lastProps[key];
    if (newValue !== lastValue) {
      console.log(key, 'New Value: ', newValue);
      console.log(key, 'Last Value: ', lastValue);
    }
  });
};

/**
 * function to log the changes in props of a component
 * to be used when debugging to detect why a re-render happens
 * @param {*} newProps the current props of the component
 * @returns {void}
 * @example
 * const MyComponent = (props) => {
 *  useDebugPropChanges(props);
 *  return <div>My Component</div>;
 * };
 */
// eslint-disable-next-line import/prefer-default-export
export const useDebugPropChanges = (newProps) => {
  const lastProps = useRef();
  // Should only run when the component re-mounts
  useEffect(() => {
    console.log('Mounted');
  }, []);
  if (lastProps.current) {
    logPropDifferences(newProps, lastProps.current);
  }
  lastProps.current = newProps;
};

export const reportSlowRequest = ({
  startTime,
  thresholdMs = 10000,
  requestLabel,
  metadata,
}) => {
  try {
    const durationMs = Date.now() - startTime;
    if (durationMs < thresholdMs) return;

    let companyId;
    let userId;
    try {
      companyId = window.sessionStorage.getItem('companyId');
      userId = window.sessionStorage.getItem('id');
    } catch {
      companyId = null;
      userId = null;
    }

    Sentry.captureMessage('Slow API request', {
      extra: {
        durationMs,
        requestLabel,
        companyId,
        userId,
        ...metadata,
      },
      tags: {
        companyId,
        userId,
      },
    });
  } catch {
    // Observability must not affect callers
  }
};
